var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-add-task"},[_c('add-task-page-with-param',{attrs:{"to-detail-on-ok":true,"detail-path":"/link-task-detail","replace-route":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }